module.exports = __webpack_public_path__ + "img/espresso.51d468cc.jpg";